export enum CustomEvent {
  //反馈相关
  CheckReview = 'check-review', //查看反馈
  CheckReviewImage = 'check-review-image', //方法查看反馈图片
  CheckVersion = 'check-version', //查看版本信息

  //模型相关
  CheckModel = 'check-model', //查看模型
  CloseModelInspector = 'close-model-inspector', //关闭模型检查器
  ClosePreviewList = 'close-preview-list', //关闭文件列表

  OpenLaunchpad = 'open-launchpad', //打开launchpad工具
  UploadAttachment = 'upload-attachment', //提交附件
  UploadVersion = 'upload-version', //提交版本

  OpenPopo = 'open-popo', //点击popo唤醒

  // 本地规范检查
  LocalCheckOnNextStep = 'local-check-on-next-step', //检查下一步
  LocalCheckOnUpload = 'local-check-on-upload', //检查上传

  // 触发质检
  TriggerQualityCheck = 'trigger-quality-check',
  // 提交新版本次数统计
  AddVersion = 'add-version',

  // ws相关
  WsConnect = 'ws-connect', //ws连接
  UseCommentTool = 'use-comment-tool', // 使用反馈工具

  // 页面内模块级PV
  ParentTaskPageView = 'ParentTaskPageView', // 父任务 PV
  AddVersionPageView = 'AddVersionPageView', // 提交版本页面 pv
  VersionPreviewPageView = 'VersionPreviewPageView', // 版本预览页面 pv
  ModalDetailPageView = 'ModalDetailPageView', // 美术模型资产详情页 pv

  // im
  OpenIM = 'open-im', // 打开IM
  //资质认证耗时
  AuthTime = 'auth-time',
  PublishTaskTime = 'publish-task-time',
  // 查看收入记录快照
  CheckIncomeSnapshot = 'check-income-snapshot',
  // 查看支出记录快照
  CheckOutcomeSnapshot = 'check-outcome-snapshot',
  //查看任务详情
  CheckRequirementDetail = 'check-requirement-detail',
  // 切换版本文件
  SwitchVersion = 'switch-version',

  // ----------------------------------------
  // 活动相关
  // ----------------------------------------

  // 点击查看优秀作品
  ActivityMediaPlay = 'activity-media-play',
}
